var map = {
	"./contact/onSelectedDelete": 1060,
	"./cpo/onSelectedDelete": 1061,
	"./customer/onSelectedDelete": 1062,
	"./forwarderPo/onSelectedDelete": 1063,
	"./incomingInvoice/onSelectedDelete": 1064,
	"./incomingPayment/onSelectedDelete": 1065,
	"./outgoingInvoice/onSelectedDelete": 1066,
	"./outgoingPayment/onSelectedDelete": 1067,
	"./outgoingQuote/onSelectedDelete": 1068,
	"./product/onSelectedDelete": 1069,
	"./receiving/onSelectedDelete": 1070,
	"./shipping/onSelectedDelete": 1071,
	"./spo/onSelectedDelete": 1072,
	"./vendor/onSelectedDelete": 1073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1059;